<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-col style="display: flex;
  flex-flow: column;
  height: 100%; padding: 0">
        <b-row style=" flex-grow : 1; margin: 0px">
            <b-col id="map_main" style="height: 100%; padding: 0px;  transition: margin-left .5s; overflow-y: hidden">
                <div style="position: absolute;
                width:100%;
                height:100%;
                top: 0; right: 0;
                bottom: 0; left: 0;"
                     id="map_container_1"
                     ref="map_container_1">
                </div>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>

    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';


    export default {
        name: "MangelLocation",
        mounted() {
            let lat = this.$route.query.lat;
            let lon = this.$route.query.lon;
            this.lat = parseFloat(lat);
            this.lon = parseFloat(lon);
            mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
            this.map = new mapboxgl.Map({
                container: 'map_container_1',
                style: 'mapbox://styles/mapbox/outdoors-v11',
                center: [this.lon, this.lat],
                zoom: 18,
                minZoom: 5,
                maxPitch: 0,
                attributionControl: false
            });

            this.map.addControl(new ZoomControl(), 'bottom-right');
            const languageControl = new LanguageControl({
                language: 'de',
            });
            this.map.addControl(languageControl);

            this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

            this.marker = null;
            this.geojson = {};
            this.showLoader();
            this.map.on('load', this.mapLoad);
        },
        data() {
            return {
                visible: true,
                mapLoaded: false,
                markers: {},
                first_load: true,
            }
        },
        methods: {
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            mapLoad() {
                this.mapLoaded = true;
                this.addLayers();
            },
            addLayers() {
                if (this.first_load) {
                    this.first_load = false;
                    setTimeout(() => {
                        if (this.marker === null) {
                            let el = document.createElement('div');
                            el.className = 'marker';

                            this.marker = new mapboxgl.Marker({
                                element: el,
                                anchor: 'center',
                            })
                                .setLngLat([this.lon, this.lat])
                                .addTo(this.map);
                        }
                        this.map.resize();
                        this.hideLoader()
                    });
                }
            },
        },
    }
</script>

<style>

    .marker {
        background-image: url('../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .black {
        color: black;
    }
    .legend {
        box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        border-radius: 4px;
    }

    .sidebar2 {
        visibility: hidden;
        width: 0;
        position: absolute;
        z-index: 1 !important;
        overflow-x: hidden;
        -webkit-transition: 0.5s;
        transition: 0.5s;
        -moz-transition: 0.5s;
        padding: 0;
        top: 50px;
        -webkit-transition-property: width, visibility;
        transition-property: width, visibility;
        -moz-transition-property: width, visibility;
        -webkit-transition-timing-function: ease;
        transition-timing-function: ease;
        -moz-transition-timing-function: ease;
    }

    .mapboxgl-ctrl-top-left {
        display: flex;
        display: flex;
        display: -moz-flex;
        display: -webkit-flex;
        display: -o-flex;
    }

    .mapboxgl-ctrl-top-left .mapboxgl-ctrl {
        display: flex;
        display: flex;
        display: -moz-flex;
        display: -webkit-flex;
        display: -o-flex;
    }
    .mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
        border-left: 1px solid #ddd;
        border-top: none;
    }

    .my-custom-control {
        color: #f00;
        background: #000;
        padding: 8px;
        border-radius: 4px;
        margin: 8px;
    }
    .mapboxgl-popup {
        max-width: 600px !important;
    }
    .mapboxgl-popup-close-button {
        font-size: 20px;
    }

    .md-button.md-theme-default.md-raised[disabled] {
        background-color: rgba(255, 255, 255, 1) !important;
        color: rgba(0,0,0,0.5) !important;
    }

    .popup-header {
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
        margin: 8px;
    }
    .popup-content {
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
        margin: 8px;
    }

</style>

<style scoped>
    @import '../../node_modules/vue-material/dist/vue-material.min.css';
    @import '../../node_modules/vue-material/dist/theme/default.css';

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
